<template>
  <!-- <div class="head">
    <div class="left"></div>
    <div class="title">
      <img :src="logo" alt />
    </div>
    <div class="right">
      <img :src="typeTableIcon" alt @click="router.push({name:'typeTablePage'})" />
    </div>
  </div> -->
  <div class="navbar">
    <img src="@/assets/img/logo1.png" alt="" />
    <span class="url">{{ url }}</span>
    <img src="@/assets/img/logo2.png" alt="" />
    <!-- <van-icon name="star-o" size="20px" /> -->
  </div>
  <p class="text0 text-shadow-pop-tl">【诸.葛.亮】致力打造，全网火爆！！！</p>
  <!-- <van-notice-bar
    left-icon="volume-o"
    :text="`淘码导航网，认证${url}，全新上线，预祝您中奖多多！！！`"
  /> -->
  <img class="img1" src="@/assets/img/shoucang.jpg" alt="" />
  <p class="text0 slide-fwd-center text1">
    【诸.葛.亮】全新预测团队，全网火爆
  </p>
  <!-- <p class="text0 text-shadow-pop-tl">【诸.葛.亮】致力打造，全网火爆！！！</p>
  <p class="text0 text-shadow-pop-tl">【诸.葛.亮】致力打造，全网火爆！！！</p> -->
  <div class="head1">
    <!-- <div class="mask">{{ url }}</div> -->
    <!-- <img class="title" src="@/assets/img/liuheV3-imgs/header.png" /> -->
    <!-- <a href="https://guhjgvf.www53923a.com/#223" target="_blank">
      <img class="img1" src="@/assets/img/liuheV3-imgs/6.gif" alt="" />
    </a> -->
  </div>
</template>

<script setup>
import typeTableIcon from "@/assets/img/typeTableIcon.png";
import logo from "@/assets/img/logo.png";
import { useRouter } from "vue-router";
const router = useRouter();

const url = window.location.hostname;

function share() {
  if (navigator.share) {
    navigator
      .share({
        title: "淘码论坛",
        text: "",
        url: window.location.href,
      })
      .then(() => console.log("Share successful"))
      .catch((error) => console.log("Error sharing:", error));
  } else {
    alert("当前浏览器不支持分享");
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  font-weight: bold;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // background-color: #a100a0;
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 999;
  font-family: "Courier New", Courier, monospace;
  position: relative;
  background: linear-gradient(to right, #a6aecb, #e7e7e9, #9ea8c5, #d9dce0);
  .url {
    position: absolute;
    left: 70px;
    top: 35px;
    color: #000;
  }
  img {
    height: 40px;
  }
}
.text0 {
  text-align: center;
  color: #c96d10;
  font-weight: bold;
  font-size: 20px;
  padding: 12px 0;
}
.text1 {
  color: #ff2900;
}
.title {
  width: 100%;
  height: 100px;
}
.img1 {
  width: 100%;
  height: 60px;
}
.head {
  width: 100vw;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  padding: 6px 10px;
  background-color: #fc9078;
  display: flex;
  flex: 1;
  justify-content: space-between;
  > div {
    width: 33.333%;
  }
  .title {
    text-align: center;
    img {
      height: 35px;
    }
  }
  .right {
    text-align: right;
    img {
      height: 35px;
      width: 65px;
    }
  }
}
.head1 {
  position: relative;
  .mask {
    width: 230px;
    height: 30px;
    background-color: #d02928;
    position: absolute;
    top: 65px;
    left: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
      "Lucida Sans", Arial, sans-serif;
    background-color: aliceblue;
    color: #fc9078;
    border-radius: 6px;
  }
}
</style>